import { isBefore, isValid, parse, startOfMonth } from 'date-fns';
import { t } from '../../../strings/i18n';
import { length, required } from '../../../xform';
export const EXPIRATION_DATE_INPUT_NAME = 'expirationDate';
const expirationDateConfig = () => [
    EXPIRATION_DATE_INPUT_NAME,
    undefined,
    'ENABLED',
    [
        required(t('errors.expirationRequired')),
        length(t('errors.expirationFormatInvalid'), 4),
        (value) => {
            const submittedDate = parse(value, 'MMyy', new Date());
            if (!isValid(submittedDate)) {
                throw new Error(t('errors.expirationDateInvalid'));
            }
        },
        (value) => {
            const beginningOfCurrentMonth = startOfMonth(new Date());
            const submittedDate = parse(value, 'MMyy', new Date());
            if (isBefore(submittedDate, beginningOfCurrentMonth)) {
                throw new Error(t('errors.expirationPast'));
            }
        }
    ]
];
export default expirationDateConfig;
